<button type="button" class="navbar-toggler" (click)="sidebarService.toggleSidebar()">
  <div *ngIf="!sidebarService.hideSidebar" class="navbar-left-arrow">&#8249;</div>
  <div *ngIf="sidebarService.hideSidebar" class="navbar-right-arrow">&#8250;</div>
</button>
